import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import * as styles from "./style.css";
import CanvasComponentsHorizontalBar from "../horizontal-bar";
import { createClassNames } from "../../../../../infrastructure/helpers";

class CanvasComponentsControlsBottom extends PureComponent {

  static defaultProps = {
    isCanvasBarShown: false,
    onCanvasSelect: () => {}
  };

  static propTypes = {
    isCanvasBarShown: PropTypes.bool,
    onCanvasSelect: PropTypes.func
  };

  render() {
    const containerStyles = [styles.container];
    if (this.props.isCanvasBarShown) {
      containerStyles.push(styles.containerShown);
    }

    const containerClass = createClassNames(containerStyles);

    return (
      <div className={containerClass}>
        <div>
          { this.props.children }
        </div>
        <CanvasComponentsHorizontalBar
          onCanvasSelect={this.props.onCanvasSelect}/>
      </div>
    );
  }
}

export default CanvasComponentsControlsBottom;


// WEBPACK FOOTER //
// ./src/app/modules/canvas/ui/components/controls-bottom/index.jsx